import React, { useState, useEffect, useMemo } from 'react';
import Translations from '../../services/translation.service';
import Call from "../../assets/img/stm-call.svg";
import Data from "../../assets/img/stm-data.svg";
import Summaries from '../../services/summaries.service';
import Helpers from "../../helpers/shared.helper";
import Plans from '../../services/plans.service';
import * as variables from '../../variables';
import Settings from '../../services/settings.service';
import Spinner from './spinner.component';
import bannerInfinity from "../../assets/img/blackInfinity.svg";
const subscriptions = [];
let prefix = "stm_sum_";
let prefix_general = "stm_general_";
const ActivationSummary = () => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const [loader, setLoader] = useState(false);
    const [numberData, setNumberData] = useState(null);
    const [localMin, setLocalMin] = useState(0);
    const [planData, setPlanData] = useState(0);

    const [minutesBonusValues, setMinutesBonusValues] = useState(0);
    const [dataBonusValues, setDataBonusValues] = useState(0);
    const [addonsValues, setAddonsValues] = useState(0);


    const numberType = useMemo(() => {
        return translationKeys[`general_vanity_name_${numberData?.VanityLevelID || 0}number`]
    }, [numberData, translationKeys])

    const getPlanDataValue = (plan, type) => {
        let value = 0;
        if (plan?.Plans?.length) {
            plan.Plans.forEach((data) => {
                if (data?.Type === type) {
                    value = data?.Value !== -1
                        ? Helpers.bytesToGBs(data?.Value)
                        : -1;
                }

            })
        }
        return value;

    }

    const getPlanMinuteValue = (plan, type) => {
        let value = 0;
        if (plan?.Plans?.length) {
            plan.Plans.forEach((data) => {
                if (data?.Type === type) {
                    value = data?.Value !== -1
                        ? Helpers.milisecondstoMinutes(data?.Value)
                        : -1;
                }
            })
        }
        return value;
    }

    useEffect(() => {
        setLoader(true);
        Summaries.getSummary()
            .then((res) => {
                if (res?.data) {
                    if (res?.data?.saved_plans[0]["Plans"]?.length) {
                        let localMinutes = getPlanMinuteValue(res?.data?.saved_plans[0], "VOICE-LCL");
                        setLocalMin(localMinutes)
                        let data = getPlanDataValue(res?.data?.saved_plans[0], "DATA");
                        setPlanData(data);
                    }
                    if (res?.data?.number_details) {
                        setNumberData(res?.data?.number_details);
                    }
                    let dataBonus = [];
                    let minutesBonus = [];
                    const freeAddons = []
                    let selectedPlanPromotions = res?.data?.saved_plans[0]?.PlanPromotions
                    if (Array.isArray(selectedPlanPromotions) && selectedPlanPromotions.length && Settings.enable_free_plan) {
                        const freePlanPromotions = selectedPlanPromotions.filter(promotion => promotion["Type"] === variables.PROMOTION_TYPE_FREE_PLAN);
                        for (let promotion of freePlanPromotions) {
                            const parsed = JSON.parse(promotion["Value"]);
                            switch (parsed.Type) {
                                case variables.PROMOTION_TYPE_VOICE_ON_NET:
                                case variables.PROMOTION_TYPE_DATA_SOCIAL:
                                    freeAddons.push(parsed);
                                    break;
                                case variables.PROMOTION_TYPE_DATA:
                                    dataBonus.push(parsed);
                                    break;
                                case variables.PROMOTION_TYPE_VOICE_LCL:
                                    minutesBonus.push(parsed);
                                    break;
                                default:
                            }
                        }
                    }
                    let dataBonusValues = Plans.getSumData(dataBonus, variables.PROMOTION_TYPE_DATA, "gb");
                    setDataBonusValues(dataBonusValues)
                    let minutesBonusValues = Plans.getSumData(minutesBonus, variables.PROMOTION_TYPE_VOICE_LCL, "min");
                    setMinutesBonusValues(minutesBonusValues)
                    let addonsValues = Plans.getSumData(freeAddons, variables.PROMOTION_TYPE_DATA_SOCIAL, "gb")
                    setAddonsValues(addonsValues)



                }
                setLoader(false);
            })
            .catch(() => {
                setLoader(false);
            });
    }, []);
    useEffect(() => {
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
                // setLoader(false);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    }, []);
    return (
        <>
            {
                loader ? <Spinner /> : < div className='stm-sum-wrapper' >

                    <div className='stm-act-card'>
                        <div className="stm-act-logo">
                            <img src={Call} alt="call" />
                            <span>
                                {translationKeys[prefix + "your_number"]}</span>
                        </div>

                        <div div className='stm-act-grid'>
                            <div className="stm-act-block-left">{numberType}</div>
                            <div className="stm-act-block-right">{numberData?.MSISDN}</div>
                        </div>

                    </div>
                    <div className='stm-act-card'>
                        <div className="stm-act-logo">
                            <img src={Data} alt="" />
                            <span>{translationKeys["scr_3.10_A_signup_step_plan_name"]}</span>
                        </div>
                        <div div className='stm-act-grid'>
                            {minutesBonusValues !== 0 || localMin !== 0 ?
                                <>
                                    <div className="stm-act-block-left">
                                        {translationKeys[prefix_general + "minutes"] + " "} / 2X
                                        {" " + translationKeys[prefix + "sms"]}</div>
                                    <div className="stm-act-block-right">
                                        {localMin < 0 || minutesBonusValues < 0 ?
                                            <img src={bannerInfinity} alt="infinity" />
                                            : localMin + minutesBonusValues}
                                        {" " + translationKeys[prefix_general + "minute_unit"]}</div></> : null}

                            {dataBonusValues !== 0 || planData !== 0 ? <>
                                <div className="stm-act-block-left">{" " + translationKeys[prefix_general + "data"]}</div>
                                <div className="stm-act-block-right">
                                    {planData < 0 || dataBonusValues < 0 ?
                                        <img src={bannerInfinity} alt="infinity" />
                                        : planData + dataBonusValues}
                                    {" " + translationKeys[prefix_general + "data_unit"]}</div>
                            </> : null}
                            {addonsValues !== 0 ? <>
                                <div className="stm-act-block-left">{" " + translationKeys["free_addons_lbl_DATA-SOCIAL"]}</div>
                                <div className="stm-act-block-right">
                                    {addonsValues < 0 ?
                                        <img src={bannerInfinity} alt="infinity" />
                                        : addonsValues}
                                    {" " + translationKeys[prefix_general + "data_unit"]}</div>
                            </> : null}

                        </div>
                    </div>
                </div >
            }

        </>
    )
}

export default ActivationSummary
